import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { array, TArrayCodec } from "../../../shared/src/codecs/types/array";
import { form, TFormCodec } from "../../../shared/src/codecs/types/form";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { string, TAnyStringCodec } from "../../../shared/src/codecs/types/string";
import { uuid, TAnyUuidCodec } from "../../../shared/src/codecs/types/uuid";

export const PublicIntroducerSearchResult = required({
    id: uuid(),
    name: string(),
});
export type TPublicIntroducerSearchResultCodec = typeof PublicIntroducerSearchResult;
export type TPublicIntroducerSearchResult = TTypeOfCodec<TPublicIntroducerSearchResultCodec>;

export const PublicIntroducerSearchForm: TFormCodec<
    TRequiredCodec<{
        query: TAnyStringCodec,
    }>,
    TRequiredCodec<{
        results: TArrayCodec<TPublicIntroducerSearchResultCodec>,
    }>
> = form(
    required({
        query: string(),
    }),
    required({
        results: array(PublicIntroducerSearchResult),
    }),
);
export type TPublicIntroducerSearchFormCodec = typeof PublicIntroducerSearchForm;
export type TPublicIntroducerSearchForm = TTypeOfCodec<TPublicIntroducerSearchFormCodec>;
